import { Grid, MenuItem, Select, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import TextArea from '../../../components/common/TextArea';
import PropTypes from 'prop-types';
import AiTrainingDataContext from '../../AiTrainingDataContext';
const { v4: uuidv4 } = require('uuid');

function TriggerSimulationJob(props) {
    const {
        jobId,
        setJobId,
        promptVersionIdToUse,
        setPromptVersionIdToUse,
        selectedRecordings,
    } = props;

    const [selectedPrompt, setSelectedPrompt] = useState('');
    const [allOrderSummPromptVersions, setAllOrderSummPromptVersions] =
        useState([]);

    const {
        //allOrderSummPromptVersions,
        fetchAllVersionsOfSummarizationPrompt,
        getOrderSummarizationPromptForVersion,
    } = useContext(AiTrainingDataContext);

    const loadVersionsData = async () => {
        let tempdata = [];
        let data = await fetchAllVersionsOfSummarizationPrompt();
        if (!data) {
            alert(
                'Failed while fetching versions for Call Summarization prompt.'
            );
            return;
        }
        if (data.length > 0) {
            tempdata = [
                ...data.map((val, index) => {
                    return {
                        id: val.id,
                        label:
                            (index === 0 ? 'latest (' : '') +
                            val.majorVersion +
                            '.' +
                            val.minorVersion +
                            (index === 0 ? ')' : ''),
                        value: val.majorVersion + '.' + val.minorVersion,
                    };
                }),
            ];
        }
        setAllOrderSummPromptVersions(tempdata);
    };

    const getOrderSummarizationPrompt = async (selectedVersionId) => {
        //debugger;
        if (!selectedVersionId) return;
        // let majorVersion = parseInt(selectedVersion.split('.')[0]);
        // let minorVersion = parseInt(selectedVersion.split('.')[1]);
        let res = await getOrderSummarizationPromptForVersion(
            selectedVersionId
        );
        setSelectedPrompt(res.prompt);
    };

    useEffect(() => {
        setJobId(uuidv4());
        loadVersionsData();
        setSelectedPrompt('');
        setPromptVersionIdToUse('');
    }, []);

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Typography variant="h6">
                    Job Id :{' '}
                    <Typography component={'span'}>{jobId} </Typography>{' '}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6">
                    {`Selected Recordings (${selectedRecordings.length}) : `}
                    {selectedRecordings.map((x) => (
                        <Typography key={x} component={'span'}>
                            {x}
                            {', '}
                        </Typography>
                    ))}
                </Typography>
            </Grid>
            <Grid item container alignItems={'center'} columnSpacing={1}>
                <Grid
                    item
                    xs={12}
                    sx={{
                        '& .MuiInputBase-root': {
                            width: '150px',
                        },
                        '& .MuiSelect-select': {
                            padding: '10px',
                        },
                    }}
                >
                    <Typography variant="h6">
                        Call Summarization Prompt Version : {'  '}
                        <Select
                            labelId="prompt-version-label"
                            id="prompt-version-select"
                            value={promptVersionIdToUse}
                            onChange={(newValue) => {
                                //debugger;
                                setPromptVersionIdToUse(newValue.target.value);
                                getOrderSummarizationPrompt(
                                    newValue.target.value
                                );
                            }}
                        >
                            {allOrderSummPromptVersions.map((item) => (
                                <MenuItem value={item.id} key={item.id}>
                                    {item.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">Prompt: </Typography>
                    <TextArea
                        minRows={21}
                        maxRows={21}
                        placeholder={'Call summarization prompt..'}
                        style={{
                            width: '99%',
                            minWidth: '100%',
                            maxWidth: '100%',
                            padding: '10px',
                        }}
                        isDisabled={true}
                        value={selectedPrompt}
                    ></TextArea>
                </Grid>
            </Grid>
        </Grid>
    );
}

TriggerSimulationJob.propTypes = {
    jobId: PropTypes.string,
    setJobId: PropTypes.func,
    promptVersionToUse: PropTypes.string,
    setPromptVersionToUse: PropTypes.func,
    selectedRecordings: PropTypes.arrayOf(PropTypes.string),
};

export default TriggerSimulationJob;
